import { CSSProperties } from "react";
import { Provider } from "react-redux";
import { Provider as PaperProvider } from "react-native-paper";
import { store } from "@/_store/store";
import { Slot } from "expo-router";
import { Toaster } from "sonner-native";
import LoadAuthToken from "@/app/LoadAuthToken";
import BottomSheetProvider from "@/context/BottomSheetProvider";
import "@/global.css"
import { GestureHandlerRootView } from "react-native-gesture-handler";
import SheetContentRenderer from "@/app/components/SheetContentRenderer";
import { StyleSheet } from "react-native";
import { useDesktopRedirect } from "@/_hooks/useDesktopRedirect";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import locale from "dayjs/locale/ru";

const notificationStyles: Record<string, CSSProperties> = {
  title: { fontWeight: "normal", fontSize: 16 },
  toastContent: { alignItems: "center", justifyContent: "center" }
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
});

dayjs.extend(localizedFormat);
dayjs.locale(locale);

const RootLayout = () => {
  useDesktopRedirect();

  return (
    <GestureHandlerRootView style={styles.root}>
      <Provider store={store}>
        <PaperProvider>
          <BottomSheetProvider onRenderContent={(activeSheet) => (
            <SheetContentRenderer activeSheet={activeSheet} />
          )}>
            <LoadAuthToken />
            <Slot />
          </BottomSheetProvider>
          <Toaster
            theme="light"
            styles={notificationStyles}
          />
        </PaperProvider>
      </Provider>
    </GestureHandlerRootView>
  );
};

export default RootLayout;
